import { theme } from "config/theme";

export const isDevelopment = () => {
    const isOurProject = ["proenem", "promedicina", "promilitares", "proraiz"].includes(theme.project.slug);

    const baseURL = isOurProject ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL_WHITELABEL;

    return baseURL?.includes("dev.");
};
